(function() {

    class TicketCustom {
        constructor(container) {
            this.container = container;
            this.plusBtns = Array.from(this.container.querySelectorAll("._BtnPlus"));
            this.minusBtns = Array.from(this.container.querySelectorAll("._BtnMinus"));
            this.quantityInputs = Array.from(this.container.querySelectorAll("input[type='number']"));
            this.crossBtns = Array.from(this.container.querySelectorAll(".ticket-cross"));
            this.form = this.container.querySelector("form");

            this.bindEvents();
        }

        bindEvents() {
            var _ = this;
            this.plusBtns.forEach((plusBtn) => plusBtn.addEventListener("click", _.handleQuantityChange.bind(this), true));
            this.minusBtns.forEach((minusBtn) => minusBtn.addEventListener("click", _.handleQuantityChange.bind(this), true));
            this.quantityInputs.forEach((quantityInput) => quantityInput.addEventListener("input`", _.handleQuantityChange.bind(this), true));
            this.form.addEventListener("submit", _.handleSubmit.bind(this), true);
            this.crossBtns.forEach((minusBtn) => minusBtn.addEventListener("click", _.handleQuantityChange.bind(this), true));
        }

        handleQuantityChange(event) {
            const wrapper = event.currentTarget.closest(".ticket-item");
            const quantityInput = event.currentTarget.closest(".ticket-item").querySelector("input[type='number']");
            const minimunQuantity = Number(quantityInput.getAttribute("min"));
            const currentVariantQuantity = Number(quantityInput.value);

            const currentOperation = event.currentTarget.dataset.name;
            let newQuantity = currentVariantQuantity;

            if (currentOperation === "plus") {
                newQuantity = currentVariantQuantity + 1;
            }
            if (currentOperation === "minus") {
                if (currentVariantQuantity === minimunQuantity) return;
                newQuantity = currentVariantQuantity - 1;
            }
            if (currentOperation === "cross") {
                newQuantity = 0;
            }

            newQuantity === minimunQuantity ? wrapper.querySelector("._BtnMinus").setAttribute("disabled", true) : wrapper.querySelector("._BtnMinus").removeAttribute("disabled");
            quantityInput.value = newQuantity;

            const variantId = quantityInput.dataset.variantId;
            const allergyInputWrapper = wrapper.querySelector(`#variant__${variantId}`);
            if (allergyInputWrapper) {
                if (newQuantity === minimunQuantity) {
                    allergyInputWrapper.querySelector("input").removeAttribute("required");
                    allergyInputWrapper.classList.add("hidden");
                } else {
                    allergyInputWrapper.querySelector("input").setAttribute("required", true);
                    allergyInputWrapper.classList.remove("hidden");
                }
            }


            this.updateAddToCart();
        }

        handleSubmit(event) {
            event.preventDefault();
            const radioValue1 = this.container?.querySelector(".radio-value-1");
            const radioValue2 = this.container?.querySelector(".radio-value-2");
            const activeVariants = this.quantityInputs.filter((input) => parseInt(input.value) > 0);
            
            // Check if there are any active variants
            if (activeVariants.length === 0) {
                console.error('No items selected');
                return;
            }

            let itemsArray = activeVariants.map((currentInput) => {
                const wrapper = currentInput.closest(".ticket-item");
                const properties = {};

                // Handle allergy inputs
                const allergyInputWrapper = wrapper.querySelector(`#variant__${currentInput.dataset.variantId}`);
                if (allergyInputWrapper) {
                    const allergyInput = allergyInputWrapper.querySelector("input");
                    if (allergyInput && allergyInput.value) {
                        properties[allergyInput.getAttribute("name")] = allergyInput.value;
                    }
                }

                // Handle radio button values
                const variantGroups = document.querySelectorAll('[data-variant-group]');
                if (variantGroups.length > 0) {
                    const selectedInput1 = variantGroups[0]?.querySelector('input[type="radio"]:checked');
                    const selectedInput2 = variantGroups[1]?.querySelector('input[type="radio"]:checked');
                    
                    if (selectedInput1 && radioValue1) {
                        properties[radioValue1.getAttribute("name")] = selectedInput1.value;
                    }
                    if (selectedInput2 && radioValue2) {
                        properties[radioValue2.getAttribute("name")] = selectedInput2.value;
                    }
                }

                return {
                    id: Number(currentInput.dataset.variantId),
                    quantity: Number(currentInput.value),
                    properties: properties
                };
            });

            const formData = { items: itemsArray };

            const submitButton = this.form.querySelector("button[type='submit']");
          
            const CartItemsQuantity = itemsArray.reduce((total, item) => (total + item.quantity), 0);
            const cartLimit = parseInt(document.querySelector('input[name="limit"]')?.value);
            const productLimit = parseInt(document.querySelector('product-info')?.dataset.limit);
            const error_message = document.querySelector('.purchase-limit');
            const total_cartItemQuantityPlusCartLimit = CartItemsQuantity + cartLimit;
            if (cartLimit && productLimit != '' && cartLimit >= productLimit || CartItemsQuantity > productLimit || total_cartItemQuantityPlusCartLimit > productLimit) {
                if(error_message) error_message.classList.remove('hidden');
                submitButton.setAttribute('disabled', true);
                setTimeout(()=>{
                  if(error_message) error_message.classList.add('hidden');
                  submitButton.removeAttribute('disabled');
                }, 3000);
                return;
            }

            // Add loading state
            // const submitButton = this.form.querySelector("button[type='submit']");
            submitButton.classList.add('loading');
            submitButton.disabled = true;

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then((response) => {
                console.log('Success:', response);
                // Redirect to cart page on success
                window.location.href = window.Shopify.routes.root + "cart";
            })
            .catch((error) => {
                console.error('Error:', error);
                // Remove loading state and re-enable button on error
                submitButton.classList.remove('loading');
                submitButton.disabled = false;
                // You might want to show an error message to the user here
            });
        }

        updateAddToCart() {
            var activeInputs = this.quantityInputs.filter((input) => parseInt(input.value) > 0);
            const totalQuantity = activeInputs.reduce((acc, curr) => acc + parseInt(curr.value), 0);
            if (totalQuantity > 0) {
                this.form.querySelector("button[type='submit']").removeAttribute("disabled");
                this.form.querySelector("button[type='submit']").querySelector("span").innerText = window.variantStrings.addToCart;
            } else {
                this.form.querySelector("button[type='submit']").setAttribute("disabled", true);
                this.form.querySelector("button[type='submit']").querySelector("span").innerText = window.variantStrings.addQuantityToProceed;
            }
        }
    }

    let ticketCustom = document.querySelector(".ticket_purchase");
    new TicketCustom(ticketCustom);

})();

// Ajax variant 

